module.exports = __webpack_public_path__ + "static/img/Kobe Logo Green.b4768d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Kobe Logo Green.png
// module id = 680
// module chunks = 0